

import SSocket from "servisofts-socket";
import geolocation from "./geolocation";
// import publicacion from "./publicacion";
// import publicacion_like from "./publicacion_like";
// import publicacion_comentario from "./publicacion_comentario";
// import servicio from "./servicio";
// import paquete from "./paquete";
// import paquete_venta from "./paquete_venta";
// import sucursal from "./sucursal";
import usuario from "./usuario";
import sigestran from "./sigestran";
import backgroundLocation from "./backgroundLocation";
import checklist from "./checklist";
export const MDL = {
    geolocation: new geolocation(),
    checklist: new checklist(),
    // publicacion: new publicacion(),
    // publicacion_like: new publicacion_like(),
    // publicacion_comentario: new publicacion_comentario(),
    usuario: new usuario(),
    // servicio: new servicio(),
    // paquete: new paquete(),
    // paquete_venta: new paquete_venta(),
    // sucursal: new sucursal(),
    backgroundLocation: new backgroundLocation(),
    sigestran: new sigestran()

};

export const componentDidMount = async () => {
    console.log("Iniciado el MDL", SSocket.api.root)
    const list = Object.values(MDL)
    for (let i = 0; i < list.length; i++) {
        const element = list[i];
        console.log("Iniciando ", element.constructor.name)
        await element.componentDidMount();

    }
    return;
}


export default MDL;
